module.exports = __webpack_public_path__ + "img/voiceExp.341c0ec8.svg";